import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#1B2548",
    "col1n": "#2E3E79",
    "col1s": "#080C19",
    "col2d": "#E0E0E0",
    "col2n": "#FFFFFF"
}
function ShiLon116({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M163.65 72.25l-.1-.5q-.2-.75-.35-1.45-.05-.3-.15-.6-.15-.75-.35-1.5-.35-1.35-.65-2.7l-.2-.6-.4-1.6q-.75-2.7-1.6-5.3-.3-1-.6-1.95-.3-.8-.55-1.6-.1-.2-.15-.35-.45-1.25-.85-2.45-.9-2.4-1.85-4.75-1-2.3-2-4.5-1.8-3.95-3.85-7.6-1-1.85-2.1-3.6-.6-.95-1.15-1.9-1.2-1.85-2.45-3.65-.9-1.2-1.75-2.35v.05l-.05-.05q.1-.05.1-.1 1.15-.75 2.25-1.6.65 0 1.55-.3.2-.05.4-.15.1-.05.25-.1 1.35-.6 3.6-3.25 2.2-2.65-.4-3.05-1.65 0-3.45-.1-6.2-.3-13.85-1.55-12.75-2.05-21.7-5.65-1.25-.5-2.45-.95l-.5-.2-.8-.3q-.6-.25-1.15-.45-1.95-.9-3.95-1.65-19.75-7.75-39.85 0-2 .75-3.95 1.65-.6.2-1.2.45-.4.15-.75.3-1.45.55-2.95 1.15-8.95 3.6-21.7 5.65-1.75.3-3.4.55-7.75 1.05-13.9 1.1-2.6.4-.4 3.05 2.25 2.65 3.6 3.25 1.3.55 2.2.55 1.1.85 2.25 1.6 0 .05.1.1-.1.05-.15.15l-1 1.4q-.4.5-.75 1.1-2.1 2.9-3.95 6.05-.85 1.45-1.65 2.9-1.5 2.7-2.85 5.55-.5.95-.95 1.95-2.05 4.45-3.8 9.25l-.9 2.4q-.15.4-.3.85-.7 2.05-1.35 4.2-.85 2.85-1.65 5.8-.1.3-.15.6l-.7 2.7-.1.5h.05q-.15.5-.25 1-.1.3-.15.6l-.3 1.4q-.4 1.7-.75 3.4v.2q-.2.9-.35 1.8l-.4 2v.05q-.05.2-.05.4v.1q.35-.3.7-.55 2.75-2.15 6.35-2.8.15-.05.3-.05l1.85-.2q6.65-.25 10.9 3.05.9.75 1.75 1.65l-2.8 11.75q-.55 2.1-1.05 4.2l-.9 3.6-.95 3.6v.25l-.05.05h.2q.25.1.5.15H16.95q2.05.5 4.15.95 30.8 7 61.4 7 30.75 0 61.3-7 2.05-.45 4.1-.95h.2q.25-.05.5-.15h.2l-.05-.2v-.1l-5.15-20.7h-.05l-.55-2.45q4.55-5.05 12.65-4.7l2.05.2q.15 0 .3.05 2.15.4 4 1.3 1.65.8 3.05 2.05V79.5q0-.15-.05-.35-.3-1.55-.55-3.05l-.1-.4q-.05-.2-.05-.4-.25-1.1-.45-2.2-.1-.45-.2-.85M91.55 43.9h-.4l.55-.05q-.058.032-.15.05z"
                    id="ShiLon116__Symbol_588_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M2.35 4.95q-.1.05-.15.15l-1 1.4q8.8 6.55 20.45 11.9 10.6 4 22.1 5.85Q24.6 20.7 8.55 9.6L7 8.45Q5.55 7.4 4.2 6.35l-1.85-1.4M22.75 0h-.1q-1.75.75-4.1 1.4-2.4.6-5.55 1.15-1.45.25-2.7.4-1.55.2-2.85.25-2.4.1-4.1.2Q1.6 3.5 0 3.25q1.1.85 2.25 1.6.8-.15 2.65-.15 1.8 0 6.75-.75 2.95-.5 4.95-1 1.3-.35 2.2-.65 2.25-.9 3.95-2.3m99.75 4.85q1.15-.75 2.25-1.6-1.6.25-3.35.15-1.7-.1-4.1-.2-1.3-.05-2.85-.25-1.3-.15-2.7-.4Q108.6 2 106.2 1.4q-2.35-.65-4.1-1.4h-.1q1.7 1.4 3.95 2.3.85.35 2.15.65 2 .5 5 1 4.95.75 6.75.75 1.85 0 2.65.15m1.05 1.65l-1-1.4q-.05-.1-.1-.1l-.05-.05-1.85 1.4q-1.35 1.05-2.8 2.1L116.2 9.6l-2 1.4Q103 18.45 88.7 22.4q-3.75 1.05-7.7 1.85 3.9-.65 7.7-1.5 7.4-1.7 14.4-4.35 11.65-5.35 20.45-11.9z"
                    id="ShiLon116__Symbol_589_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1s}
                    d="M4.45.1q-.2.1-.25.3L0 21.85v.2q0 .1.1.15v.05q.1.15.3.2.2.05.4-.05.15-.15.2-.35L5.2.65V.6q.05-.2-.05-.35Q5 .05 4.8 0q-.2-.05-.35.1M115.4.6v.05l4.2 21.4q.05.2.2.35.2.1.4.05t.3-.2v-.05q.1-.05.1-.15v-.2L116.4.4q-.05-.2-.25-.3-.15-.15-.35-.1l-.2.1q-.1.05-.15.15-.1.15-.05.35z"
                    id="ShiLon116__Symbol_590_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M1.2 0H0v112.25h1.2V0z"
                    id="ShiLon116__Symbol_591_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2d}
                    d="M6.55.95q-.1-.3-.45-.5-.75-.5-1.75-.45H4.1Q3.05-.05 2.35.45q-.3.2-.45.45-.45 1 0 2.05.2.5.75.55l-2.5 7.25q-.6 1.9 1.4 2.1H6.7q2-.2 1.45-2.1L5.7 3.6h-.1l.2-.1q.55-.05.75-.6.3-1 0-1.95M4.05 5.5l.1-.4.1.4 1.85 5.55H4.25q-.05 0-.1.05-.05-.05-.1-.05H2.2L4.05 5.5z"
                    id="ShiLon116__Symbol_592_0_Layer0_0_FILL"
                />
                <path
                    fillOpacity={0.502}
                    d="M248.6 264.25q-.05-.2-.25-.3-.15-.15-.35-.1-.107.027-.2.1-.08.057-.15.15-.1.15-.05.35v.05l4.2 21.4q.05.2.2.35.2.1.4.05t.3-.2v-.05q.1-.05.1-.15v-.2l-4.2-21.45m-111.2.25v-.05q.05-.2-.05-.35-.15-.2-.35-.25-.2-.05-.35.1-.2.1-.25.3l-4.2 21.45q-.017.113 0 .2l.05.15q.031.025.05.05.1.15.3.2.2.05.4-.05.15-.15.2-.35l4.2-21.4z"
                    id="ShiLon116__Layer1_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#ShiLon116__Symbol_588_0_Layer0_0_FILL"
                transform="translate(110 205.3)"
                id="ShiLon116__col1n"
            />
            <use
                xlinkHref="#ShiLon116__Symbol_589_0_Layer0_0_FILL"
                transform="translate(130.1 223.65)"
                id="ShiLon116__col1d"
            />
            <use
                xlinkHref="#ShiLon116__Symbol_590_0_Layer0_0_FILL"
                transform="translate(132.2 263.85)"
                id="ShiLon116__col1s"
            />
            <use
                xlinkHref="#ShiLon116__Symbol_591_0_Layer0_0_FILL"
                transform="translate(191.9 205.35)"
                id="ShiLon116__col2n"
            />
            <use
                xlinkHref="#ShiLon116__Symbol_592_0_Layer0_0_FILL"
                transform="translate(188.4 205.3)"
                id="ShiLon116__col2d"
            />
            <use xlinkHref="#ShiLon116__Layer1_0_FILL" />
        </g></g>
    )
}
export default ShiLon116
